var _rect, _rect2, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrivacyPolicyRightTwo(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 353,
    height: 1005,
    viewBox: "0 0 353 1005",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    y: 211,
    width: 794,
    height: 794,
    fill: "url(#paint0_radial_4646_19665)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 97,
    width: 750,
    height: 750,
    fill: "url(#paint1_radial_4646_19665)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_4646_19665",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(397 608) rotate(90) scale(397)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F27489"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F6F6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_4646_19665",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(472 375) rotate(90) scale(375)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7B173"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F6F6",
    stopOpacity: 0
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacyPolicyRightTwo);
export default __webpack_public_path__ + "static/media/privacyPolicy_right_two.65c4601a857b898f0e8b875f5b23532a.svg";
export { ForwardRef as ReactComponent };